<div class="d-flex align-items-center" [ngClass]="{'pt-2 pb-2': isInIngredientCard}">
  <ng-container>
    <fts-tags [tags]="showableIngredients" [isIngredientTag]="true" (tagClicked)="tagClicked.emit($event)"></fts-tags>
  </ng-container>

  <button 
    *ngIf="(ingredient?.tags.length - showableIngredients.length) > 0" 
    class="badge action-bg-color action-inverse-text-color ms-2 tag-indicator-btn"
    [ngClass]="{'selection-inverse-bg-color selection-text-color': isSelectedIngredientCard && isInIngredientCard}"
    [ngbPopover]="nonShowableIngredientsList" 
    #popover="ngbPopover"
    [attr.aria-label]="'component.item_editor.choice.ingredient.ingredient_card.tags_popover' | translate: {extra_ingredient_num: nonShowableIngredients.length, tag: nonShowableIngredients.length > 1 ? 'tags' : 'tag'}">
    <span *ngIf="!popover.isOpen()">+{{nonShowableIngredients.length}}</span>
    <span *ngIf="popover.isOpen()"><fa-icon [icon]="faX"></fa-icon></span>
  </button>
</div>

<ng-template #nonShowableIngredientsList>
  <div class="ingredient-popover">
    <fts-tags 
      [tags]="nonShowableIngredients" 
      [isIngredientTag]="true" 
      [inPopover]="true"
      (tagClicked)="tagClicked.emit($event)"></fts-tags>
  </div>
</ng-template>
